import { render, staticRenderFns } from "./BoothSearch.vue?vue&type=template&id=ecdb225e"
import script from "./BoothSearch.vue?vue&type=script&lang=ts"
export * from "./BoothSearch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports